import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import DayJS from 'react-dayjs';
import { MnemoLoading, BoxDanger, Title, SupportoTecnico, TimeWatcher } from "components/misc";
import { MnemoCallout } from "components/misc/MnemoCallout";
import { learningService, networkErrorHelper } from "libs";

import { CourseSection } from 'components/learning/CourseSection';

import {
    Container
} from 'design-react-kit';

class M24Lesson extends Component {

    state = {
        rCode: 0,
        myCourse: 0,
        homeConfig: 0,
        loading: true,
        loadingError: false
    };

    componentDidMount() {

        // get registration code from parameter
        const { rCode } = this.props.match.params;
        this.setState({ rCode });

        this.loadCourse(rCode);
    }

    loadCourse(rCode) {
        learningService
            .courseMainM24(rCode, 1)
            .then(({ data }) => {

                const { userCourse, course, homeConfig } = data.payload;
                this.setState({ myCourse: userCourse, course, homeConfig, loading: false });
            })
            .catch(error => {

                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }

                this.setState({ loading: false, loadingError: true });
            });
    }

    render() {

        const { loading, loadingError, myCourse, course, homeConfig, rCode } = this.state;
        if (loading) return (<MnemoLoading></MnemoLoading>);
        
        return (

            <>
                {loadingError ? (<BoxDanger className="mt-4">Si è verificato un errore durante
                    il caricamento dei dati del corso, se il problema persiste <SupportoTecnico /> </BoxDanger>) : (
                    <>
                        <section className="my-4">
                            <Container>
                                <Title>Insegnamenti in presenza</Title>
                                <MnemoCallout>
                                    <b>Codice corso</b>: {course.code}<br />
                                    <b>Codice registrazione</b>: {rCode}<br />
                                    <b>data Inizio</b>: <DayJS format="DD/MM/YYYY">{myCourse.dateStart}</DayJS><br />
                                    <TimeWatcher rCode={rCode} metadata={course.metadata} />
                                </MnemoCallout>
                            </Container>
                        </section>
                        <section className="my-4">
                            <Container>
                                {Object.values(homeConfig).map((row, i) => (
                                    <CourseSection key={`course-section-${i}`} sectionInfo={row} rCode={rCode} />
                                ))}
                            </Container>
                        </section>
                    </>
                )}
            </>);
    }
}

export default withRouter(M24Lesson);